/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import Select, { components, CSSObjectWithLabel } from 'react-select';
// import { IMAGES } from '../../../utils/dummyJSON';
import downArrow from '../../../_supplier/assets/media/svg_supplier/down-arrow.svg';
const CaretDownIcon = () => {
  return (
    <img
      className="img-fluid pe-1"
      src={downArrow}
      alt=""
    />
  );
};
const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <CaretDownIcon />
    </components.DropdownIndicator>
  );
};

const CheckboxOption = (props: any) => {
  const { isSelected, children, ...rest } = props;
  return (
    <components.Option {...rest} isSelected={isSelected}>
      <div className="form-check form-check-custom form-check-solid form-check-lg d-flex align-items-center">
        <input
          className="form-check-input me-4"
          type="checkbox"
          checked={isSelected}
          readOnly
          tabIndex={-1}
        />
        <span>{children}</span>
      </div>
    </components.Option>
  );
};

const SquareRadioOption = (props: any) => {
  const { isSelected, children, ...rest } = props;
  return (
    <components.Option {...rest} isSelected={isSelected}>
      <div className="form-check form-check-custom form-check-solid form-check-lg d-flex align-items-center">
        <input
          className="form-check-input me-4"
          type="radio"
          checked={isSelected}
          readOnly
          tabIndex={-1}
          style={{ borderRadius: '4px' }}
        />
        <span>{children}</span>
      </div>
    </components.Option>
  );
};

const customFilterOption = (option: any, rawInput: any) => {
  const label = option.data.title ?? option.data.label ?? '';
  const input = rawInput.toLowerCase();
  const text = label.toLowerCase();
  return text.includes(input);
};
const CustomSelect = (props: any) => {
  return (
    <>
      <Select
        // menuIsOpen={true}
        isOptionDisabled={props.isOptionDisabled}
        isOptionSelected={props.isOptionSelected}
        components={{
          DropdownIndicator,
          ...(props.showCheckbox ? { Option: CheckboxOption } : {}),
          ...(props.showRadio ? { Option: SquareRadioOption } : {}),
          ...(props.components || {}),
        }}
        hideSelectedOptions={props.hideSelectedOptions}
        value={props.value}
        menuPosition={'fixed'}
        isClearable={props.isClearable}
        menuPortalTarget={document.body}
        placeholder={props.placeholder}
        defaultValue={props.default}
        isLoading={props.isLoading}
        onChange={props.onChange}
        onInputChange={props.onInputChange}
        onMenuClose={props.onMenuClose}
        onMenuOpen={props.onMenuOpen}
        onMenuScrollToBottom={props.onMenuScrollToBottom}
        filterOption={customFilterOption}
        isDisabled={props.disabled || (props.isLoading ? false : !(props.options?.length))}
        options={props.options}
        isSearchable={props.isSearchable}
        styles={{
          option: (base: CSSObjectWithLabel) => ({
            ...base,
            borderBottom: `1px solid #e0e0df`,
            ':last-child': {
              borderBottom: 'none',
            },
            margin: '0px',
            background: 'white',
            padding: '16px',
            ':active': {
              ...base[':active'],
              color: '#1b74e4',
              background: '#f1faff',
            },
            ':hover': {
              ...base[':active'],
              color: '#1b74e4',
              background: '#f1faff',
            },
            color: '#1a1a1a',
            fontSize: props.optionFontSize ? props.optionFontSize : '1.154rem',
            fontWeight: '500',
          }),
          control: (base: CSSObjectWithLabel) => ({
            ...base,
            border: props.border
              ? '0.5px solid ' + props.border
              : '0.5px solid #e0e0df',
            boxShadow: 'none',
            minHeight: props.minHeight ? props.minHeight : '60px',
            height: 'auto',
            minWidth: props.minWidth ? props.minWidth : '220px',
            width: props.width ? props.width : 'auto',
            borderRadius: props.radiusTable ? props.radiusTable : '8px',
            padding: '0px',
            fontSize: props.controlFontSize
              ? props.controlFontSize
              : '1.231rem',
            fontWeight: '600',
            backgroundColor: props.backgroundColor,
            ':hover': {
              ...base[':hover'],
              border: props.border
                ? '0.5px solid ' + props.border
                : '0.5px solid #e0e0df',
            },
          }),
          menu: (base: CSSObjectWithLabel) => ({
            ...base,
            boxShadow: '0 0 15px 0 rgba(0, 0, 0, 0.1)',
            color: '#1a1a1a',
          }),
          menuList: (base: CSSObjectWithLabel) => ({
            ...base,
            paddingTop: '0px',
            paddingBottom: '0px',
            borderRadius: '5px',
            width: 'auto',
            color: '#1a1a1a',
          }),
          menuPortal: (base: CSSObjectWithLabel) => ({
            ...base,
            zIndex: 9999,
          }),
          indicatorSeparator: (base: CSSObjectWithLabel) => ({
            ...base,
            display: 'none',
          }),
          indicatorsContainer: (base: CSSObjectWithLabel) => ({
            ...base,
            color: '#f9f9f9',
            strokeWidth: '5px',
          }),
          multiValueRemove: (base: CSSObjectWithLabel) => ({
            ...base,
            height: '12px',
            ':hover': {
              backgroundColor: '#e7f1fd',
            },
            svg: {
              height: '22px',
              width: '22px',
              fill: '#7c7c7c',
            },
          }),
          multiValue: (base: CSSObjectWithLabel) => ({
            ...base,
            backgroundColor: '#e7f1fd',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '11px 14px',
            borderRadius: '6px',
            fontSize: '1.231rem',
            fontWeight: '600',
            height: '42px',
            width: 'auto',
          }),
          multiValueLabel: (base: CSSObjectWithLabel) => ({
            fontSize: '1.231rem',
            fontWeight: '600',
          }),
        }}
        isMulti={props.isMulti}
        closeMenuOnSelect={props.closeMenuOnSelect}
      />
    </>
  );
};
export { CustomSelect };
